












































const namespace = 'calendar';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import SingleLocation from '@/modules/calendar/components/locations/SingleLocation.vue';
import DropdownFilter from '@/modules/calendar/components/DropdownFilter.vue';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { IFilters, IFilter } from '@/modules/calendar/interfaces/IFilter';
import { onlyUnique } from '@/utils/filters';
import { tryGetFromLocalStorage } from '@/utils/cache';

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IDropdownChange {
    odataName: string;
    values: string[];
}

@Component({
    name: 'CalendarDropdownFilters',
    components: {
        SingleLocation,
        DropdownFilter,
    },
})
export default class CalendarDropdownFilters extends Vue {
    @Prop() public events!: ICalendarData[];
    @Prop() public filters!: IFilters;
    @Getter('isMobile', { namespace }) private isMobile!: number;
    @Getter('hiddenFilters', { namespace }) private hiddenFiltersList!: string;
    private allEvents: ICalendarData[] = [];
    private filtersData: IFilters = {};

    private get mobileView() {
        return this.isMobile;
    }

    private get hiddenFilters() {
        return this.hiddenFiltersList.split(',');
    }

    private get calendarFiletrs() {
        const filters = [
            {
                name: 'weekDaysSelect',
                odataName: 'WeekDayId',
                inputplaceholder: this.getTranslation('filters.Week day'),
                options: this.weekDaysSelectOptions,
            },
            {
                name: 'instructorsSelect',
                odataName: 'InstructorName',
                inputplaceholder: this.getTranslation('filters.Teacher'),
                options: this.instructorsSelectOptions,
            },
            {
                name: 'actsSelect',
                odataName: 'Name',
                inputplaceholder: this.getTranslation('filters.Workshop'),
                options: this.actsSelectOptions,
            },
            {
                name: 'addressSelect',
                odataName: 'Address',
                inputplaceholder: this.getTranslation('filters.Location'),
                options: this.addressesSelectOptions,
            },
            {
                name: 'advanceLevelSelect',
                odataName: 'AdvanceLevel',
                inputplaceholder: this.getTranslation('filters.Advance Level'),
                options: this.advanceLevelSelectOptions,
            },
            {
                name: 'groupDanceStyleSelect',
                odataName: 'GroupDanceStyle',
                inputplaceholder: this.getTranslation('filters.Style'),
                options: this.groupDanceStyleSelectOptions,
            },
            // {
            //     name: 'danceStyleCategorySelect',
            //     odataName: 'DanceStyleCategories',
            //     inputplaceholder: this.getTranslation('filters.Dance Style Category'),
            //     options: this.groupDanceStyleCategorySelectOptions,
            // },
            // {
            //     name: 'statusSelect',
            //     odataName: 'StartDate',
            //     inputplaceholder: this.getTranslation('filters.Status'),
            //     options: this.statusSelectOptions,
            // },
            {
                name: 'groupTypeSelect',
                odataName: 'GroupType',
                inputplaceholder: this.getTranslation('filters.Class Type'),
                options: this.groupTypeSelectOptions,
            },
        ];

        return filters;
    }

    public isHidden(name: string): boolean {
        const contain = this.hiddenFilters ? this.hiddenFilters.filter(hiddenFilter => hiddenFilter === name) : [];
        return contain.length === 1 ? true : false;
    }

    public isAllHidden(): boolean {
        const all = [
            'WeekDayId',
            'InstructorName',
            'Name',
            'Address',
            'AdvanceLevel',
            'GroupDanceStyle',
            'DanceStyleCategories',
            'StartDate',
            'GroupType',
        ];
        return this.hiddenFilters ? all.every(elem => this.hiddenFilters.indexOf(elem) > -1) : false;
    }

    public getvaluesFromUrl(odataName: string): Array<string | number> {
        return this.filters[odataName] ? this.filters[odataName].map((filter: IFilter) => filter.details.value) : [];
    }

    private getTranslation(key: string) {
        return this.$t(key).toString();
    }

    public get instructorsSelectOptions() {
        const odataName = 'InstructorName';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .map((el: ICalendarData) => el[odataName])
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    public get actsSelectOptions() {
        const odataName = 'Name';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .map((el: ICalendarData) => el[odataName])
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    public get addressesSelectOptions() {
        const odataName = 'Address';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .map((el: ICalendarData) => el[odataName])
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    public get advanceLevelSelectOptions() {
        const odataName = 'AdvanceLevel';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .map((el: ICalendarData) => el[odataName])
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    public get groupDanceStyleSelectOptions() {
        const odataName = 'GroupDanceStyle';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .map((el: ICalendarData) => el[odataName])
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    public get groupDanceStyleCategorySelectOptions() {
        const odataName = 'DanceStyleCategories';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .filter((el: ICalendarData) => el[odataName] !== undefined && el[odataName].length > 0)
            .flatMap((el: ICalendarData) =>
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                el[odataName].filter((val: any) => val.IsActive).map((val: any) => val.Name),
            )
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    public get weekDaysSelectOptions() {
        return [
            { text: this.getTranslation('weekDays.thursday'), value: '4' },
            { text: this.getTranslation('weekDays.friday'), value: '5' },
            { text: this.getTranslation('weekDays.saturday'), value: '6' },
            { text: this.getTranslation('weekDays.sunday'), value: '7' },
        ];
    }

    public get statusSelectOptions() {
        return ['aktywne', 'przyszłe'].map(x => ({ text: x, value: x }));
    }

    public get groupTypeSelectOptions() {
        const odataName = 'GroupType';
        const events = this.filters[odataName] ? this.allEvents : this.events;
        return events
            .map((el: ICalendarData) => el[odataName])
            .filter(onlyUnique)
            .sort()
            .map(x => ({ text: x, value: x }));
    }

    private get ajaxDone() {
        this.allEvents = tryGetFromLocalStorage('allCachedEvents');
        this.filtersData = this.filters;
        return this.allEvents.length;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    private handleDropdownChange({ odataName, values, odataProperty, navigationProperty }: IDropdownChange): void {
        if (odataName === 'StartDate') {
            this.handleDropdownStatusChange({ odataName, values });
            return;
        }

        const details: IFilter[] = values.map((value: string) => ({
            odataName,
            details: {
                odataName: odataProperty || odataName,
                compareType: 'eq',
                value,
                navigationProperty,
            },
        }));
        this.$emit('updateFilters', { odataName, details });
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    private handleDropdownStatusChange({ odataName, values }): null {
        if (values.length === 0) {
            const details: object[] = [];
            this.$emit('updateFilters', { odataName, details });
            return null;
        }

        const timeFilter: IFilter[] = [];
        if (values.includes('przyszłe')) {
            const currentTimestamp = new Date().toISOString();
            const detail = {
                odataName,
                details: {
                    odataName,
                    compareType: 'gt',
                    value: currentTimestamp,
                },
            };
            timeFilter.push(detail);
        }

        if (values.includes('aktywne')) {
            const currentTimestamp = new Date().toISOString();
            const detail = {
                odataName,
                details: {
                    odataName,
                    compareType: 'lt',
                    value: currentTimestamp,
                },
            };
            timeFilter.push(detail);
        }

        this.$emit('updateFilters', { odataName, details: timeFilter });
    }
}
